import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";


function formatPrice(price) {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
}

function getLowestPrice(tractors) {
  if (!tractors || !tractors.length) return null;
  return tractors.reduce(
    (min, tractor) => Math.min(min, tractor.price),
    tractors[0].price
  );
}


function Product({ product }) {

  const [isHovered, setIsHovered] = useState(false);
  const imageZoomClass = isHovered ? "image-zoom" : "";
  const lowestPrice = getLowestPrice(product.tractors);
  const formattedLowestPrice = formatPrice(lowestPrice);

  
  
  return (
    <Card
      className="product-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={`/product/${product._id}`}>
        <div className="product-background">
          <Card.Img
            src={product.image}
            alt={product.name}
            className={`product-image ${imageZoomClass}`}
          />
        </div>
      </Link>

      <Card.Body>
        <Link
          to={`/product/${product._id}`}
          className="product-title-link linkStyle"
        >
          <Card.Title>
            <span className="product-title">{product.name} </span>
            {product.category === "tractor" && (
              <>
                {" - "}
                <span className="product-hp">{product.horsepower} HP</span>
              </>
            )}
          </Card.Title>
        </Link>

        {lowestPrice ? (
          <Card.Text
            className="product-price"
            style={{ marginTop: "-10px", marginBottom: "-10px" }}
          >
            <span className="product-dollar-character">$</span>
            <span className="product-dollar-price">
              {formattedLowestPrice.split(".")[0].toLocaleString()
            }
            </span>
            <span className="product-dollar-cents">
              .{formattedLowestPrice.split(".")[1]}
            </span>
          </Card.Text>
        ) : (
          <Card.Text className="product-price"></Card.Text> 
        )}

        {product.category === "tractor" && (
          <div>
            <Card.Text className="product-tractor-type">
              <span style={{ fontSize: "0.8rem" }}>Type:</span>{" "}
              <span
              className="product-tractor-type-text"
              >
                {product.tractor_type.charAt(0).toUpperCase() +
                  product.tractor_type.slice(1)}
              </span>
            </Card.Text>
          </div>
        )}

        <Card.Text className="product-description">
          {product.short_description}
        </Card.Text>

        <Button
          as={Link}
          to={`/product/${product._id}`}
          className="button product"
        >
          View Details
        </Button>
      </Card.Body>
    </Card>
  );
}

export default Product;
